import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const MusicalNoteFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M9.7 17.56C9.7 19.6 8.34 20.94 6.24 20.94C4.52 20.94 3.24 19.96 3.22 18.52C3.2 17.06 4.6 15.84 6.4 15.84C7.06 15.84 7.72 16.02 8.06 16.3V5.2L18.84 2.8V15.96C18.84 18 17.48 19.34 15.38 19.34C13.66 19.34 12.36 18.34 12.36 16.92C12.36 15.46 13.76 14.24 15.54 14.24C16.2 14.24 16.86 14.42 17.2 14.7V9.04L9.7 10.72V17.56Z" />
    </SvgIcon>
  );
});
